import React from 'react';

export default function CheckOut() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.7218 16.0005C30.7218 23.8553 24.3543 30.2228 16.4996 30.2228C8.64485 30.2228 2.27734 23.8553 2.27734 16.0005C2.27734 8.14583 8.64485 1.77832 16.4996 1.77832C24.3543 1.77832 30.7218 8.14583 30.7218 16.0005Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M13.7889 21.3328L11.5222 9.99946M13.0333 9.2439C13.0333 7.57477 14.3864 6.22168 16.0556 6.22168C17.7247 6.22168 19.0778 7.57477 19.0778 9.2439M10.7667 9.99946H21.3444L23.6111 21.3328H8.5L10.7667 9.99946Z"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M15.6992 16.7119H24.4992V18.8453V23.112H15.6992V18.8453V16.7119Z"
        fill="white"
      />
      <path
        d="M15.6992 18.8453H24.4992M17.1659 20.9787H19.3659M15.6992 16.7119H24.4992V23.112H15.6992V16.7119Z"
        stroke="black"
        strokeLinejoin="round"
      />
    </svg>
  );
}
